/**
 * @flow
 * Created by neo on 01.06.17.
 */
import {observable, computed} from 'mobx';
import Flight from '../Flight';
import Client from '../Client';
import Passenger from './Passenger';
import BackendFactory from '../../Services/BackendFactory';
import moment from 'moment-timezone';

export default class Booking {

  @observable id: string;
  @observable passengers: Array<Passenger> = [];
  @observable is_exclusive: boolean = false;
  @observable start_time: string;
  @observable first_name: string;
  @observable last_name: string;
  @observable email: string;
  @observable phone: string;
  @observable note: string;
  @observable check_safety_info: boolean = false;
  @observable check_insurance_info: boolean = false;

  constructor(json?: any) {
    if(json) {
      this.id = json.id;
      this.is_exclusive = json.is_exclusive;
      this.passengers = (json.passengers || []).map(p => new Passenger(p));
      this.start_time = json.start_time;
      this.first_name = json.first_name;
      this.last_name = json.last_name;
      this.email = json.email;
      this.phone = json.phone;
      this.note = json.note;
      this.check_insurance_info = json.check_insurance_info;
      this.check_safety_info = json.check_safety_info;
    }
  }

  @computed get totalWeight() {
    const passengers = this.passengers.slice();
    let total = 0;
    for(let passenger of passengers) {
      total += Number(passenger.weight || 0);
    }
    return total;
  }

  @computed get canChangePassengers() {
    // const meetingTime = moment(this.flight.flightInfo.meetingTime);
    // const diff = meetingTime.diff(moment(), 'hours');
    // return diff >= 24;
    return true;
  }

  async updatePassengers() {
    const backend = await BackendFactory();
    const res = backend.post(`/booking/${this.id}/passengers`, {
      passengers: this.passengers.slice(),
      booking: {
        check_insurance_info: this.check_insurance_info,
        check_safety_info: this.check_safety_info
      }
    });
    return res;
  }

  static async get(bookingId: string): Promise<?Booking> {
    const backend = await BackendFactory();
    const res = await backend.get(`/booking/${bookingId}/passengers`);
    if(res.ok) {
      return new Booking({
        ...res.data,
        id: bookingId
      });
    }
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/App/Store/Booking/index.js